import { useEffect, useState } from "react";
import { Plus, FileText, ImageIcon } from "lucide-react";
import { api } from "../api.js";

function isImage(url) {
  return url && /\.(png|jpe?g|gif|webp|svg)$/i.test(url);
}

function FilePreview({ url, name }) {
  if (!url) return null;
  if (isImage(url)) {
    return (
      <a href={url} target="_blank" rel="noopener" className="dx-order-file-preview">
        <img src={url} alt={name || "Datei"} />
      </a>
    );
  }
  return (
    <a href={url} target="_blank" rel="noopener" className="dx-file-link">
      <FileText size={14} /> {name || "Datei öffnen"}
    </a>
  );
}

export default function AuftraegeScreen() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNew, setShowNew] = useState(false);

  const load = () => {
    setLoading(true);
    api.orders().then((rows) => { setOrders(rows); setLoading(false); }).catch(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const inProduction = orders.filter((o) => o.stage === "produktion");

  return (
    <div>
      <div className="dx-screen-header">
        <h2>Aufträge in Produktion</h2>
        <button className="dx-btn dx-btn--primary" onClick={() => setShowNew(true)}><Plus size={16} /> Manuell anlegen</button>
      </div>

      {loading ? <p className="dx-muted">Lade…</p> : null}
      {!loading && inProduction.length === 0 ? <p className="dx-muted">Aktuell keine Aufträge in Produktion.</p> : null}

      <div className="dx-order-grid">
        {inProduction.map((o) => (
          <div key={o.id} className="dx-card">
            <div className="dx-detail-header">
              <h3>{o.customer_name}</h3>
              <span className="dx-badge dx-badge--produktion">Produktion</span>
            </div>

            <FilePreview url={o.file_url} name={o.file_name} />

            <div className="dx-detail-grid">
              <div><span className="dx-label">Produkt</span><div>{o.product}</div></div>
              <div><span className="dx-label">Größe</span><div>{o.size || "-"}</div></div>
              <div><span className="dx-label">LED</span><div>{o.led ? "Ja" : "Nein"}</div></div>
              {o.qty ? <div><span className="dx-label">Menge</span><div>{o.qty}</div></div> : null}
              <div><span className="dx-label">Wert</span><div>{o.value ? `${o.value} €` : "-"}</div></div>
              <div><span className="dx-label">Quelle</span><div>{o.source === "manuell" ? "Manuell" : "Anfrage"}</div></div>
            </div>
            {o.customer_request ? (
              <div><span className="dx-label">Kundenanfrage</span><p style={{ whiteSpace: "pre-wrap" }}>{o.customer_request}</p></div>
            ) : null}
            <div>
              <span className="dx-label">Arbeitsauftrag</span>
              <textarea className="dx-textarea" rows={3} defaultValue={o.description || ""} onBlur={(e) => api.updateOrder(o.id, { description: e.target.value })} />
            </div>
            <div className="dx-action-row">
              <button className="dx-btn dx-btn--primary" onClick={() => api.doneOrder(o.id).then(load)}>Erledigt</button>
              <button className="dx-btn dx-btn--danger" onClick={() => api.cancelOrder(o.id).then(load)}>Absagen</button>
            </div>
          </div>
        ))}
      </div>

      {showNew ? <NewOrderModal onClose={() => setShowNew(false)} onCreated={() => { setShowNew(false); load(); }} /> : null}
    </div>
  );
}

function NewOrderModal({ onClose, onCreated }) {
  const [form, setForm] = useState({ customerName: "", product: "", size: "", led: false, qty: "", value: "", description: "" });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    await api.createOrder({ ...form, qty: form.qty ? Number(form.qty) : null, value: form.value ? Number(form.value) : null });
    onCreated();
  };

  return (
    <div className="dx-modal-overlay" onClick={onClose}>
      <form className="dx-modal" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <h3>Auftrag manuell anlegen</h3>
        <input className="dx-input" placeholder="Kundenname" required value={form.customerName} onChange={(e) => set("customerName", e.target.value)} />
        <input className="dx-input" placeholder="Produkt" required value={form.product} onChange={(e) => set("product", e.target.value)} />
        <input className="dx-input" placeholder="Größe" value={form.size} onChange={(e) => set("size", e.target.value)} />
        <label className="dx-checkbox-row">
          <input type="checkbox" checked={form.led} onChange={(e) => set("led", e.target.checked)} /> LED
        </label>
        <input className="dx-input" placeholder="Menge (nur Pokal)" type="number" value={form.qty} onChange={(e) => set("qty", e.target.value)} />
        <input className="dx-input" placeholder="Wert (€)" type="number" value={form.value} onChange={(e) => set("value", e.target.value)} />
        <textarea className="dx-textarea" placeholder="Arbeitsauftrag" rows={3} value={form.description} onChange={(e) => set("description", e.target.value)} />
        <div className="dx-action-row">
          <button type="submit" className="dx-btn dx-btn--primary">Anlegen</button>
          <button type="button" className="dx-btn dx-btn--ghost" onClick={onClose}>Abbrechen</button>
        </div>
      </form>
    </div>
  );
}
